import { render } from "./WhyApogee.vue?vue&type=template&id=48bf9f58"
import script from "./WhyApogee.vue?vue&type=script&lang=js"
export * from "./WhyApogee.vue?vue&type=script&lang=js"

import "./WhyApogee.vue?vue&type=style&index=0&id=48bf9f58&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__